import styled from 'styled-components';
import HappyRatingStarSvg from './happyRatingStar.svg';

const HappyRatingStarIcon = styled(HappyRatingStarSvg as JSX.Element)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  margin: ${props => props.margin || '0.2rem'};
  fill: ${props => props.fill || props.theme.colors.goYellow.base};
  cursor: pointer;
`;

export default HappyRatingStarIcon;
